var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-picker"},[_c('date-picker',{attrs:{"range":true,"confirm":true,"clearable":false,"editable":false,"confirm-text":_vm.confirmText,"placeholder":_vm.placeholder,"value":_vm.value},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }